// extracted by mini-css-extract-plugin
export default {"Likes":"Likes_Likes__JMbYm","Like":"Likes_Like__592nU","floatAway":"Likes_floatAway__p3CPW","Avatar":"Likes_Avatar__UVToh"};